<div class="tw-w-full tw-py-4 tw-pb-8 tw-pl-4 tw-font-lexend">
  <h1 class="tw-text-600 tw-mb-2 tw-font-normal" i18n="@@ourTreatmentPhilosophy"><span class="tw-font-bold tw-pl-1">Our Treatment</span> Philosophy</h1>
  <div class="tw-w-full tw-max-w-screen tw-overflow-x-scroll hide-scrollbar tw-flex tw-items-center tw-gap-2">
    <ng-container *ngFor="let card of TreatmentPhilosophyData[displayLanguage]; let i = index">
      <div [ngClass]="{'tw-mr-4': i === TreatmentPhilosophyData[displayLanguage].length - 1}">
        <app-treatment-philosophy-card
          [card]="card"
          [expanded]="false"
          (collapsedCardClick)="cardClick($event)">
        </app-treatment-philosophy-card>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="showSelected !== null">
    <div class="tw-fixed tw-h-screen tw-w-full tw-inset-0 tw-z-50">
      <div class="tw-fixed tw-inset-0 tw-bg-black tw-opacity-70 tw-z-30" (click)="closeSelected()"></div>
      <div class="tw-top-1/2 -tw-translate-y-1/2 tw-h-fit tw-relative tw-z-40">
        <swiper #swiperComponent class="tw-h-full" [config]="carouselConfig">
          <ng-container *ngFor="let card of TreatmentPhilosophyData[displayLanguage]; let i = index">
            <app-treatment-philosophy-card
              *swiperSlide
              [card]="card"
              [expanded]="true"
              (onCardClose)="closeSelected()">
            </app-treatment-philosophy-card>
          </ng-container>
        </swiper>
      </div>
    </div>
  </ng-container>
</div>
